import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import moment from "moment"

//empty state
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_voucher.png"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const ViewVoucher = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [listType, setListType] = useState("active")
  const [oid, setOid] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (query.get("id")) {
      setOid(query.get("id"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      getVoucherList()
      console.log("use effect")
    }
  }, [token, listType])

  const [voucherData, setVoucherData] = useState(null)
  const getVoucherList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_evoucher")
    urlencoded.append("member_id", uid)
    urlencoded.append("filter_by_order_id", oid)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request evoucher", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_EVOUCHER, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setVoucherData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [searchData, setSearchData] = useState("")
  function onSubmitSearchField(e) {
    e.preventDefault()
    // history.push("/product-search?q=" + searchData)
    getVoucherList()
  }

  function onChangeSearchField(e) {
    setSearchData(e.target.value)
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  backgroundColor: "#F5F5F5",
                  paddingBottom: "76px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {/* {"Friends"} */}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    {voucherData &&
                      voucherData.map((data, index) => (
                        <Row
                          className="g-0 mb-3"
                          key={"productVoucher" + index}
                          style={{ backgroundColor: "white" }}
                        >
                          <Col className="px-3 mb-0 pb-3">
                            <Link to={"/voucher-details?id=" + data.id}>
                              <Card
                                className="py-3 mb-0 shadow-none"
                                style={{
                                  borderRadius: "0",
                                  borderBottom: "1px",
                                  borderBottomColor: "#D6D6D6",
                                  borderBottomStyle: "solid",
                                }}
                              >
                                <Row>
                                  <Col xs="auto">
                                    <img
                                      src={
                                        // "https://dummyimage.com/88x88/000/ffffff.png&text=Voucher"
                                        data.image
                                      }
                                      className="avatar-lg"
                                      alt=""
                                      style={{
                                        borderRadius: "8px",
                                        width: "132px",
                                        height: "88px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </Col>
                                  <Col>
                                    <Row>
                                      <Col>
                                        <strong>
                                          <span className="font-size-15 text-dark">
                                            {data.product_name}
                                          </span>
                                        </strong>
                                      </Col>
                                    </Row>
                                    <Row
                                      style={{
                                        position: "absolute",
                                        bottom: 0,
                                        right: "16px",
                                      }}
                                    >
                                      <Col className="mr-auto text-end">
                                        <i
                                          className="bx bx-cookie align-middle font-size-20"
                                          style={{ color: "#A5A5A5" }}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Card>
                            </Link>
                            {data.order_evouchers &&
                              data.order_evouchers.map((vdata, index) => (
                                <Link to={"/voucher-details?id=" + data.id}>
                                  <Card
                                    key={"evoucher" + data.id + "-" + vdata.id}
                                    className="py-3 mb-0 shadow-none"
                                    style={{
                                      borderRadius: "0",
                                      borderBottom: "1px",
                                      borderBottomColor: "#D6D6D6",
                                      borderBottomStyle: "solid",
                                    }}
                                  >
                                    <Row>
                                      <Col xs="auto">
                                        <img
                                          src={
                                            // "https://dummyimage.com/88x88/000/ffffff.png&text=Voucher"
                                            vdata.image
                                          }
                                          className="avatar-sm"
                                          alt=""
                                          style={{
                                            borderRadius: "8px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      </Col>
                                      <Col>
                                        <Row>
                                          <Col>
                                            <strong>
                                              <span className="font-size-15 text-dark">
                                                {vdata.name}
                                              </span>
                                            </strong>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col>
                                            {vdata.status == "Used" ? (
                                              <span
                                                className="font-size-15"
                                                style={{ color: "#B1B1B1" }}
                                              >
                                                {moment(
                                                  vdata.mark_used_date,
                                                  "DD-MM-YYYY"
                                                ).format(
                                                  "[Used on:] D MMM YYYY"
                                                )}
                                              </span>
                                            ) : (
                                              <span
                                                className="font-size-15"
                                                style={
                                                  moment().isAfter(
                                                    moment(
                                                      vdata.expiry_date,
                                                      "DD-MM-YYYY"
                                                    )
                                                  )
                                                    ? { color: "#E93C48" }
                                                    : { color: "#45A461" }
                                                }
                                              >
                                                {moment().isAfter(
                                                  moment(
                                                    vdata.expiry_date,
                                                    "DD-MM-YYYY"
                                                  )
                                                )
                                                  ? moment(
                                                      vdata.expiry_date,
                                                      "DD-MM-YYYY"
                                                    ).format(
                                                      "[Expired on:] D MMM YYYY"
                                                    )
                                                  : moment(
                                                      vdata.expiry_date,
                                                      "DD-MM-YYYY"
                                                    ).format(
                                                      "[Redeem before:] D MMM YYYY"
                                                    )}
                                                {/* {"Expired: 7 Jun 2021"} */}
                                              </span>
                                            )}
                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </Card>
                                </Link>
                              ))}
                            {/* <Link to="#">
                              <Card className="py-3 mb-0">
                                <Row>
                                  <Col xs="auto">
                                    <img
                                      src={
                                        "https://dummyimage.com/88x88/000/ffffff.png&text=Voucher"
                                      }
                                      className="avatar-sm"
                                      alt=""
                                      style={{
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </Col>
                                  <Col>
                                    <Row>
                                      <Col>
                                        <strong>
                                          <span className="font-size-15 text-dark">
                                            {"Voucher Title"}
                                          </span>
                                        </strong>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col>
                                        <span
                                          className="font-size-15"
                                          style={{ color: "#B1B1B1" }}
                                        >
                                          {"Used on: 7 Jun 2021"}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Card>
                            </Link> */}
                          </Col>
                        </Row>
                      ))}
                    {/* <Row className="g-0" style={{ backgroundColor: "white" }}>
                      <Col className="px-3 mb-0">
                        <Link to="/voucher-details">
                          <Card className="py-3 mb-0">
                            <Row>
                              <Col xs="auto">
                                <img
                                  src={
                                    "https://dummyimage.com/88x88/000/ffffff.png&text=Voucher"
                                  }
                                  className="avatar-lg"
                                  alt=""
                                  style={{
                                    borderRadius: "8px",
                                  }}
                                />
                              </Col>
                              <Col>
                                <Row>
                                  <Col>
                                    <strong>
                                      <span className="font-size-15 text-dark">
                                        {"Voucher Title"}
                                      </span>
                                    </strong>
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    position: "absolute",
                                    bottom: 0,
                                  }}
                                >
                                  <Col>
                                    <span
                                      className="font-size-15"
                                      style={{ color: "#45A461" }}
                                    >
                                      {"Use before: 7 Jun 2021"}
                                    </span>
                                  </Col>
                                </Row>
                                <Row
                                  style={{
                                    position: "absolute",
                                    bottom: 0,
                                    right: "16px",
                                  }}
                                >
                                  <Col className="mr-auto text-end">
                                    <i
                                      className="bx bx-cookie align-middle font-size-20"
                                      style={{ color: "#A5A5A5" }}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Card>
                        </Link>
                      </Col>
                    </Row> */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(ViewVoucher)

ViewVoucher.propTypes = {
  t: PropTypes.any,
}
